import * as React from "react";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";

interface Props {
    value: string;
    onClick: (value: string) => void;
    onMouseDown: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export default class TouchNumber extends React.Component<Props> {
    protected handleClick = (e: React.MouseEvent<HTMLDivElement>): void => {
        e.stopPropagation();

        this.props.onClick(this.props.value);
    };

    public render(): React.ReactNode {
        let content: string | React.ReactNode = this.props.value;

        if(this.props.value === "back") {
            content = <FontAwesomeLight icon="backspace" />;
        }

        return (
            <div className="touch-number" onClick={this.handleClick} onMouseDown={this.props.onMouseDown}>
                {content}
            </div>
        );
    }
}
